export default "__VITE_ASSET__D6OwV9Yi__"